import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { canAccessModule } from "@/lib/permissions/permissions";

export function RequireModule({ module, children }) {
  const { user } = useAuth();
  if (user && !canAccessModule(user.role, module)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
